import { Endpoint } from '@philips-emr/hpms-provider-commons';
import { HpmsFormTechnicalVisitAPI } from '@philips-emr/hpms-provider-components';
import { FetchAPI, FormAPI } from '@philips-emr/tws-components';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { SubObject } from './technical-visit-forms-controller';

export function handleSubmitSimple(
  event: FormAPI,
  nrSeqVisit: string | number,
): void {
  void HttpService.post(Endpoint.POST.FORM_TECHNICAL_VISIT, { nrSeqVisit }, { body: parseEntries(event) });
}

export function handleSubmitWithAPIs(
  event: FormAPI,
  nrSeqVisit: string | number,
  fetchQuestions: FetchAPI,
  formQuestions: HpmsFormTechnicalVisitAPI,
): void {
  void HttpService.post(Endpoint.POST.FORM_TECHNICAL_VISIT, { nrSeqVisit }, { body: parseEntries(event) }).then(() => {
    fetchQuestions.forceFetch();
    formQuestions.setEditing(false);
    formQuestions.setLocked(false);
  });
}

function parseEntries(event: FormAPI): any {

  let nrSeqFormPr, nrSeqAnswer;
  const recordsDsjustification = [];
  const recordsAutoComplete: { nrSeqFormPr: number; nrSeqAnswer: number | null; }[] = [];
  for (const [key, value] of Object.entries(event.record)) {

    if (!key.includes('label__')) {

      if (key.includes('answers__')) {
        nrSeqFormPr = Number(key.split('answers__')[1]);
        nrSeqAnswer = (value as SubObject).code || null;
        recordsAutoComplete.push({ 'nrSeqFormPr': nrSeqFormPr, 'nrSeqAnswer': nrSeqAnswer });
      }

      if (key.includes('justification__')) {
        nrSeqFormPr = Number(key.split('justification__')[1]);
        recordsDsjustification.push({ 'nrSeqFormPr': nrSeqFormPr, 'dsJustification': value });
      }
    }
  }

  return recordsDsjustification.map((justification) => ({
    ...recordsAutoComplete.find((o) => o.nrSeqFormPr === justification.nrSeqFormPr),
    ...justification,
  })) as unknown as any;

}
